exports.components = {
  "component---src-components-page-tsx": () => import("./../../../src/components/Page.tsx" /* webpackChunkName: "component---src-components-page-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

